import { t } from "i18next";
import * as z from "zod";

import { SUBSCRIPTION_STATUSES } from "@/features/shared/api/enums";

/**
 * Schéma du formulaire de souscription d'une entreprise à un plan
 * (`POST /CompanySubscriptions/add`, guide §6.5).
 *
 * Factory (règle projet) : créé via `createCompanySubscriptionSchema()`
 * et mémoïsé au niveau composant sur la langue courante — jamais
 * d'instance exportée.
 */
export const createCompanySubscriptionSchema = () =>
  z.object({
    companyPartyId: z
      .string()
      .trim()
      .min(1, { message: t("requiredFieldError") })
      .uuid({ message: t("invalidFieldError") }),
    planId: z
      .string()
      .trim()
      .min(1, { message: t("requiredFieldError") })
      .uuid({ message: t("invalidFieldError") }),
    status: z.enum(SUBSCRIPTION_STATUSES, {
      errorMap: () => ({ message: t("requiredFieldError") }),
    }),
    startDate: z
      .string()
      .trim()
      .min(1, { message: t("requiredFieldError") }),
    nextBillingDate: z.string().trim().or(z.literal("")).optional(),
  });

export type CompanySubscriptionFormValues = z.infer<
  ReturnType<typeof createCompanySubscriptionSchema>
>;
